import { FC } from 'react';
import { LogoProps } from './types';

const IsoLogo: FC<LogoProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="85.576"
      height="91.938"
      viewBox="0 0 85.576 91.938"
      className={className ?? ''}
    >
      <path
        d="M0,49.252C0,30.725,12.861,16.566,29.273,11.488V33.5h.006a20.265,20.265,0,0,0-8.328,15.84c0,13.344,9.832,23.1,21.831,23.1s21.837-9.764,21.837-23.1a20.116,20.116,0,0,0-7.677-15.332V24.576a22.262,22.262,0,0,0-27.663-.521V2.041A46.106,46.106,0,0,1,42.788,0,46.61,46.61,0,0,1,56.942,2.252v9.432c16.1,5.26,28.634,19.289,28.634,37.564,0,25.033-17.973,42.689-42.788,42.689S0,74.285,0,49.252Z"
        fill="#fff"
      />
    </svg>
  );
};

export default IsoLogo;
